import { saveUserData2, saveUserToDb } from "services/firebase";
import AlertContext from "components/Common/ModalAlert";
import pinzApiService from "services/pinzApiService";
import { Button } from "components/Common/button";
import { useParams } from "react-router-dom";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import Text from "components/Common/Text";
import { useAuth } from "hooks/useAuth";

export default function ExtendedAuthForm() {
  const { user } = useAuth();

  const [showNoGhinForm, setShowNoGhinForm] = useState(false);

  const { eventId, teeTimeId, teamId } = useParams();

  const [blocked, setBlocked] = useState(false);

  const { info } = useContext(AlertContext);

  const {
    handleSubmit,
    formState: { errors },
    resetField,
    register,
  } = useForm({});

  const skipGhinDetails = () => {
    setShowNoGhinForm(!showNoGhinForm);
    if (!showNoGhinForm) {
      resetField("lastName");
      resetField("ghinNumber");
    }
    if (showNoGhinForm) {
      resetField("userHandicap");
      resetField("userName");
    }
  };

  const onSubmit = async (data) => {
    setBlocked(true);
    if (user.phone) {
      try {
        const res = await saveUserToDb({
          uid: user.uid,
          patch: {
            phone: user.phone,
            handicap: 0,
            name: data.lastName,
            venmoAccount: data.venmoAccount,
            manuallyProvided: true,
          },
        });

        if (!res) {
          setBlocked(false);
          info(
            // eslint-disable-next-line max-len
            "We could not locate your information in the PINZ system. Please remain calm and try entering your information again",
          );
          // skipGhinDetails();
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        setBlocked(false);
      }
    }

    if (data.userHandicap) {
      try {
        await saveUserData2({
          uid: user.uid,
          patch: {
            phone: user.phone,
            handicap: +data.userHandicap,
            name: data.userName,
            venmoAccount: data.venmoAccount,
            manuallyProvided: true,
            gender: data.gender,
          },
        });

        await pinzApiService.createPinzUser({
          id: user.uid,
          phone: user.phone,
          displayName: data.userName,
          matchId: eventId,
          teeTimeId,
          teamId,
          venmoAccount: data.venmoAccount,
          teeTimeTimestamp: new Date(),
        });
        setBlocked(false);
      } catch (e) {
        // eslint-disable-next-line no-alert
        alert(e);
        setBlocked(false);
      }
    }
  };

  function venmoField() {
    return (
      <div>
        <Text as="P3" bold mt={10}>
          Your Venmo account (optional)
        </Text>
        <div style={{ position: "relative", width: "100%", zIndex: 0 }}>
          <input
            {...register("venmoAccount", { required: false })}
            className="venmoField"
            placeholder="username or email"
            style={{
              height: 52,
              width: "100%",
              minWidth: 329,
              borderRadius: 16,
              marginTop: 8,
              paddingLeft: 34,
            }}
          />
          <Text
            as="P1"
            style={{
              position: "absolute",
              left: 16,
              top: 23,
              color: "black",
            }}
          >
            @
          </Text>
        </div>
      </div>
    );
  }
  function noGHINForm() {
    return (
      <form>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Text as="P3" bold>
            Your name
          </Text>
          <input
            {...register("userName", { required: showNoGhinForm })}
            type="text"
            placeholder="Your name"
            style={{
              height: 52,
              width: "100%",
              minWidth: 329,
              borderRadius: 16,
              marginTop: 8,
              paddingLeft: 10,
            }}
          />
          <Text as="P3" bold mt={10}>
            Your Golf Handicap Index
          </Text>
          <input
            {...register("userHandicap", {
              required: showNoGhinForm,
              pattern: /^\d*\.?\d+$/,
            })}
            type="number"
            placeholder="1.2"
            style={{
              height: 52,
              width: "100%",
              minWidth: 329,
              borderRadius: 16,
              marginTop: 8,
              paddingLeft: 10,
              border: errors.userHandicap && "2px solid #ff375f",
            }}
          />

          <Text as="P3" bold mt={10}>
            Your gender
          </Text>
          <div style={{ flexDirection: "row", display: "flex" }}>
            <div>
              <Text as="C1" bold mt={10}>
                Male
              </Text>
              <input
                type="radio"
                value="M"
                {...register("gender", { required: true })}
              />
            </div>
            <div style={{ marginLeft: 20 }}>
              <Text as="C1" bold mt={10}>
                Female
              </Text>
              <input
                type="radio"
                value="F"
                {...register("gender", { required: true })}
              />
            </div>
          </div>

          {venmoField()}

          <Text as="C2" mt={10} style={{ margin: "10px 16px" }}>
            By signing up for PINZ you agree to the Terms & Conditions.
          </Text>
          <Button
            title="Book Time & Finish"
            style={{ width: "100%", marginTop: 10 }}
            onPress={handleSubmit(onSubmit)}
            type="submit"
            blocked={blocked}
          />
          <Button
            title="Back to GHIN verification"
            style={{
              width: "100%",
              backgroundColor: "gray",
              marginTop: 10,
            }}
            onPress={skipGhinDetails}
            type="submit"
          />
        </form>
      </form>
    );
  }

  function lastNameAndGHINForm() {
    return (
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Text as="P3" bold>
            Your Name
          </Text>
          <input
            {...register("lastName", { required: !showNoGhinForm })}
            type="text"
            placeholder="First Last"
            style={{
              height: 52,
              width: "100%",
              minWidth: 329,
              borderRadius: 16,
              marginTop: 8,
              paddingLeft: 10,
              border: errors.lastName && "2px solid #ff375f",
            }}
          />
          {/* <Text as="P3" bold mt={10}>
            GHIN® number
          </Text>
          <input
            {...register("ghinNumber", {
              required: !showNoGhinForm,
              pattern: /^[0-9]*$/,
            })}
            type="number"
            maxLength={11}
            placeholder="GHIN Number"
            style={{
              height: 52,
              width: "100%",
              minWidth: 329,
              borderRadius: 16,
              marginTop: 8,
              paddingLeft: 10,
              border: errors.ghinNumber && "2px solid #ff375f",
            }}
          /> */}
          {/* {venmoField()} */}
          <Text as="C2" mt={10} style={{ margin: "10px 16px" }}>
            By signing up for PINZ you agree to the Terms & Conditions.
          </Text>
          {errors.ghinNumber && (
            <Text as="C1" ta="center">
              {errors.ghinNumber.message}
            </Text>
          )}
          <Button
            title="Complete"
            style={{ width: "100%", marginTop: 10 }}
            onPress={handleSubmit(onSubmit)}
            type="submit"
            blocked={blocked}
          />
          {/* <Button
            title="Copy? No GHIN? Enter handicap manually"
            style={{
              width: "100%",

              backgroundColor: "gray",
              marginTop: 10,
            }}
            onPress={skipGhinDetails}
            type="submit"
          /> */}
        </form>
      </div>
    );
  }

  return <div>{showNoGhinForm ? noGHINForm() : lastNameAndGHINForm()}</div>;
}
